var render, staticRenderFns
import script from "./Rail.vue?vue&type=script&lang=tsx"
export * from "./Rail.vue?vue&type=script&lang=tsx"
import style0 from "./Rail.vue?vue&type=style&index=0&id=1a33e5c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a33e5c8",
  null
  
)

export default component.exports